import React, {useEffect, useState} from 'react';
import {List, ChevronDown, ArrowUp} from 'lucide-react';

export default function ArticleContents({headings}) {
  const [active, setActive] = useState('');
  const [progress, setProgress] = useState(0);
  const [subsections, setSubsections] = useState(false);
  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      const body = document.querySelector('.article-layout .prose');
      if (!body) return;
      const rect = body.getBoundingClientRect();
      const travel = Math.max(1, rect.height - Math.min(window.innerHeight - 120, rect.height / 2));
      setProgress(Math.round(Math.min(1, Math.max(0, (120 - rect.top) / travel)) * 100));
      let current = '';
      for (const heading of headings) {
        if (!subsections && heading.level === 3) continue;
        const element = document.getElementById(heading.id);
        if (element && element.getBoundingClientRect().top <= 150) current = heading.id;
      }
      setActive(current);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    update();
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule);
    return () => {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      cancelAnimationFrame(frame);
    };
  }, [headings, subsections]);
  if (headings.length < 3) return null;
  return <>
    <div className="reading-progress" role="progressbar" aria-label="Reading progress" aria-valuemin={0} aria-valuemax={100} aria-valuenow={progress}><span style={{transform:`scaleX(${progress / 100})`}}/></div>
    <nav className="article-contents reader-contents" aria-label="Article contents">
      <details open>
        <summary><List size={20}/><span>In this guide</span><small>{headings.length} sections</small><ChevronDown size={18}/></summary>
        <label className="contents-options"><input type="checkbox" checked={subsections} onChange={event=>setSubsections(event.target.checked)}/>Show subsections</label>
        <ol>{headings.filter(heading=>subsections||heading.level===2).map((heading,index) => <li key={`${heading.id}-${index}`} className={heading.level===3?'contents-subsection':undefined}>
          <a href={`#${encodeURIComponent(heading.id)}`} aria-current={active===heading.id?'location':undefined}><span className="contents-number" aria-hidden="true">{String(index+1).padStart(2,'0')}</span><span>{heading.title}</span></a>
        </li>)}</ol>
      </details>
      <div className="contents-footer"><span>{progress}% read</span><a href="#main" aria-label="Back to article top"><ArrowUp size={15}/>Back to top</a></div>
    </nav>
  </>;
}
